import classNames from 'classnames'
import { MatchPairsAnswerOption } from '../../../../../../../../../types/commonTypes'
import layoutStyles from '../AnswerOptionLayout.module.css'
import styles from './MatchPairsAnswer.module.css'
import { MatchPairsSide } from './MatchPairsSide'

type MatchPairsCorrectAnswersProps = {
  answerOption: MatchPairsAnswerOption
}

export const MatchPairsCorrectAnswers: React.FC<MatchPairsCorrectAnswersProps> = ({ answerOption }) => {
  return (
    <div className={layoutStyles.answerOptionLeftColumn}>
      <div className={styles.matchPairsIncorrectContent}>
        <div className={classNames(styles.matchPairsIncorrectColumn, styles.matchPairsSuccess)}>
          <MatchPairsSide side={answerOption.left} isSmall />
          <MatchPairsSide side={answerOption.right} isSmall />
        </div>
      </div>
    </div>
  )
}
